export default __webpack_public_path__ + "static/media/Boots of the Doomsayer.46e3c440.jpg";